let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9YYIE")).then(() => parcelRequire('1uyZT'));